export const RANGE_FORMAT = 'YYYY-MM-DDTHH';
export const URL_FORMAT = 'YYYY-MM-DD';
export const TOTALS_FORMAT = URL_FORMAT;
export const CREATING_FORMAT = 'YYYY-MM-DDTHH:mm';
export { REQUEST_FORMAT } from '../../utils/formatDate';

export const MONTH_FORMAT = 'YYYY-MM-DDT';
export const COMPARE_FORMAT = 'YYYY-MM-DD';
